import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import rateCodeService from '../services/rateCodeService';
import './AddCorporateProfilePage.css';

const EditRateCodePage = () => {
    const navigate = useNavigate();
    const { ppId, rateCodeId } = useParams();
    const [searchParams] = useSearchParams();
    const ruleId = searchParams.get('ruleId');
    const backUrl = ruleId ? `/apps/payment-porter/${ppId}/rules/${ruleId}` : `/apps/payment-porter/${ppId}`;
    const [form, setForm] = useState(null);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        rateCodeService.getById(ppId, rateCodeId).then(res => {
            const r = res.data?.rateCode;
            if (r) {
                setForm({
                    rateCode:     r.rate_code      || '',
                    rateCodeName: r.rate_code_name || '',
                });
            }
        }).catch(() => setErrors({ submit: 'Failed to load rate code' }));
    }, [ppId, rateCodeId]);

    const set = (field, value) => {
        setForm(f => ({ ...f, [field]: value }));
        setErrors(e => ({ ...e, [field]: undefined }));
    };

    const validate = () => {
        const e = {};
        if (!form.rateCode.trim()) e.rateCode = 'Rate Code is required';
        if (!form.rateCodeName.trim()) e.rateCodeName = 'Rate Code Name is required';
        return e;
    };

    const handleSave = async () => {
        const e = validate();
        if (Object.keys(e).length) { setErrors(e); return; }
        setSaving(true);
        try {
            await rateCodeService.update(ppId, rateCodeId, {
                rate_code:      form.rateCode,
                rate_code_name: form.rateCodeName,
                active:         true,
            });
            navigate(backUrl);
        } catch (err) {
            setErrors({ submit: err.response?.data?.error?.message || 'Failed to save rate code' });
        } finally {
            setSaving(false);
        }
    };

    if (!form) return <div className="acp-page"><div className="acp-card" style={{ color: '#6b7280' }}>Loading...</div></div>;

    return (
        <div className="acp-page">
            <div className="acp-card">
                <div className="acp-card-header">
                    <h1 className="acp-title">Edit Rate Code</h1>
                    <p className="acp-subtitle">Update rate code configuration</p>
                </div>

                <div className="acp-divider" />

                <div className="acp-body">
                    <div className="acp-field">
                        <label className="acp-label">Rate Code <span className="acp-required">*</span></label>
                        <input
                            className={`acp-input${errors.rateCode ? ' acp-input-error' : ''}`}
                            type="text"
                            placeholder="e.g., CORP, GOV, PKG"
                            value={form.rateCode}
                            onChange={e => set('rateCode', e.target.value)}
                            autoFocus
                        />
                        {errors.rateCode && <span className="acp-error-msg">{errors.rateCode}</span>}
                    </div>

                    <div className="acp-field">
                        <label className="acp-label">Rate Code Name <span className="acp-required">*</span></label>
                        <input
                            className={`acp-input${errors.rateCodeName ? ' acp-input-error' : ''}`}
                            type="text"
                            placeholder="e.g., Corporate Rate, Government Rate"
                            value={form.rateCodeName}
                            onChange={e => set('rateCodeName', e.target.value)}
                        />
                        {errors.rateCodeName && <span className="acp-error-msg">{errors.rateCodeName}</span>}
                    </div>
                </div>

                {errors.submit && <div className="acp-error-msg" style={{ margin: '0 0 1rem' }}>{errors.submit}</div>}
                <div className="acp-footer">
                    <button
                        className="acp-btn-cancel"
                        onClick={() => navigate(backUrl)}
                        disabled={saving}
                    >
                        Cancel
                    </button>
                    <button
                        className="acp-btn-create"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditRateCodePage;
